import { Column } from 'material-table';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { IEarningReportTypes } from 'common/src/types';
import { CustomMaterialTable } from 'components/CustomMaterialTable';



export default function Earningreports() {
  const { t } = useTranslation();

  const settings = useSelector(state => state.settingsdata.settings);
  const earningreportsdata = useSelector(state => state.earningreportsdata);

  const columns: Column<IEarningReportTypes>[] = [
    { title: t('year'), field: 'year' },
    { title: t('months'), field: 'monthsName' },
    { title: t('booking_count'), field: 'total_rides' },
    { title: t('Gross_trip_cost'), render: rowData => (parseFloat(rowData.tripCost) + parseFloat(rowData.cancellationFee)).toFixed(settings?.decimal), },
    { title: t('trip_cost_driver_share'), field: 'rideCost' },
    { title: t('cancellationFee'), field: 'cancellationFee' },
    { title: t('convenience_fee'), field: 'convenienceFee' },
    { title: t('Discounts'), field: 'discountAmount' },
    { title: t('Profit'), render: rowData => (parseFloat(rowData.convenienceFee) + parseFloat(rowData.cancellationFee) - parseFloat(rowData.discountAmount)).toFixed(settings?.decimal) },
  ];


  return (
    <CustomMaterialTable
      columns={columns}
      title={'earning_reports'}
      isLoading={earningreportsdata.loading}
      data={earningreportsdata.Earningreportss ?? []}
    />
  );
}